import { useDeleteMeMutation } from '@entities/Authentication/rtk-query.ts';
import type React from 'react';
import { useCallback } from 'react';
import { usePersonalRedirect } from '@pages/personal/model.ts';
import { EditAndDeleteDropdown } from '@widgets/shared/EditAndDeleteDropdown/index.ts';
import { PageBackButton } from '@features/common/PageBackButton';
import { getFullNameM, getUserBirthDay, getUserGender } from '@shared/helpers';
import { useAppDispatch, useAuthToken, useUser } from '@shared/hooks';
import { Card, ListBody, PageHead } from '@shared/ui';
import { openDialogModal } from '@src/library/redux/modal/index.ts';
import { Image, Info } from 'library/components/profile';
import * as st from './styles.module.scss';

export const ProfileClient: React.FC = () => {
  const { user } = useUser();
  const { doRedirectOnPrevPage } = usePersonalRedirect();
  const [deleteMe, { isLoading: isDeletingMe }] = useDeleteMeMutation();
  const dispatch = useAppDispatch();
  const { removeToken } = useAuthToken();

  const onDelete = useCallback(
    () =>
      dispatch(
        openDialogModal({
          title: 'Удаление профиля',
          confirmText: 'Удалить',
          declineText: 'Отмена',
          text:
            'Вы действительно хотите удалить профиль? \n' +
            '\n' +
            'Все данные вашего профиля будут удалены без возможности восстановления',
          isNeedClose: true,
          isButtonsRevert: true,
          buttonClassName: st.modalButton,
          textClassName: st.modalText,
          confirm: async () => {
            // console.log('deleting');
            const resp = await deleteMe();
            if (!resp?.error) {
              removeToken();
            }
          },
        })
      ),
    [dispatch, deleteMe, removeToken]
  );

  const name = getFullNameM(user?.first_name, user?.middle_name, user?.last_name);
  const gender = getUserGender(user) || '';
  const date = getUserBirthDay(user) || '';

  return (
    <>
      <PageHead
        Left={<PageBackButton onClick={() => doRedirectOnPrevPage('/')} />}
        Center={'Профиль'}
        Right={
          <EditAndDeleteDropdown
            onDelete={onDelete}
            isDeleting={isDeletingMe}
            editText={'Редактировать'}
          />
        }
      />
      <ListBody>
        <Card className={st.profile}>
          <div className={st.photo}>
            <Image url={user?.photo} />
          </div>
          <div className={st.info}>
            <span className={st.name}>{name}</span>
            {user?.phonenumber && (
              <Info
                data={user?.phonenumber.replace(
                  /(\d)(\d{3})(\d{3})(\d{2})(\d{2})/,
                  `$1 ($2) $3-$4-$5`
                )}
              />
            )}
            {user?.email && <Info data={user?.email} />}
            {gender && <Info data={gender} />}
            {date && <Info data={date} />}
          </div>
        </Card>
      </ListBody>
    </>
  );
};
